export type SpinnerVariant = 'default' | 'overlay';
